import { db } from './firebase.js';
import {
    collection,
    addDoc,
    updateDoc,
    doc,
    getDocs,
    query,
    where,
    orderBy,
    serverTimestamp
} from "firebase/firestore";
import { GoogleGenerativeAI, HarmCategory, HarmBlockThreshold } from '@google/generative-ai';
import { AuthService } from './authService.js';

export const DemandService = {

    // ... (rest of methods)

    /**
     * Genera el prompt para Gemini basado en los hechos seleccionados
     * @param {Array} facts Lista de hechos del historial
     * @param {Object} strategy Estrategia (pretensiones, fundamentos)
     */
    async generateDemandWithAI(facts, strategy) {
        const apiKey = await AuthService.getGeminiApiKey();
        if (!apiKey) throw new Error("API Key no disponible");

        const genAI = new GoogleGenerativeAI(apiKey);
        const model = genAI.getGenerativeModel({
            model: 'gemini-2.0-flash-lite-001',
            safetySettings: [
                { category: HarmCategory.HARM_CATEGORY_HARASSMENT, threshold: HarmBlockThreshold.BLOCK_NONE },
                { category: HarmCategory.HARM_CATEGORY_HATE_SPEECH, threshold: HarmBlockThreshold.BLOCK_NONE },
                { category: HarmCategory.HARM_CATEGORY_SEXUALLY_EXPLICIT, threshold: HarmBlockThreshold.BLOCK_NONE },
                { category: HarmCategory.HARM_CATEGORY_DANGEROUS_CONTENT, threshold: HarmBlockThreshold.BLOCK_NONE },
            ]
        });

        const prompt = `
            Actúa como un abogado experto en derecho procesal civil. Redacta una DEMANDA formal basada en la siguiente información:

            HECHOS PROBADOS (Del Historial):
            ${facts.map(f => `- [${f.date}] ${f.description || f.title}`).join('\n')}

            ESTRATEGIA JURÍDICA:
            - Pretensiones: ${strategy.pretensiones}
            - Fundamentos de Derecho: ${strategy.fundamentos}
            - Pruebas Clave: ${strategy.pruebas}

            ESTRUCTURA REQUERIDA:
            1. ENCABEZADO (Juzgado, Partes)
            2. HECHOS (Narrativa cronológica persuasiva basada en los hechos provistos)
            3. PRETENSIONES (Claras y numeradas)
            4. FUNDAMENTOS DE DERECHO (Artículos y doctrina aplicable)
            5. PRUEBAS (Listado)
            6. PETITORIO FINAL

            Tu tono debe ser formal, contundente y técnicamente preciso.
        `;

        const result = await model.generateContent(prompt);
        return result.response.text();
    }
};
